/* eslint-disable camelcase */
import { GTMEvent } from '~/lib/gtm/declarations'

export const adaptCheckStoreAvailability = (storeStockStatus: string) => {
  return {
    event: GTMEvent.CHECK_STORE_AVAILABILITY,
    store_stock_status: storeStockStatus,
  }
}
